module.exports = __webpack_public_path__ + "static/media/details-5-image-2.4115a11d.jpg";